import { render } from "./wheelNavigation.vue?vue&type=template&id=3b47d28f"
import script from "./wheelNavigation.vue?vue&type=script&lang=js"
export * from "./wheelNavigation.vue?vue&type=script&lang=js"

import "./wheelNavigation.vue?vue&type=style&index=0&id=3b47d28f&lang=scss"

import exportComponent from "C:\\Users\\jekr\\Documents\\studievalg-digital-tool\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__